import * as R from 'ramda';

type UpdateFn = (id: string, updateFn: (item: any) => any, state: Record<string, any>) => Record<string, any>;

export const update: UpdateFn = R.curry((id, updateFn, items) => (
  items[id]
    ? R.assoc(id, updateFn(items[id]), items)
    : items
));
